/* eslint-disable */
import React from 'react';
import { useSelector } from 'react-redux';
import { useLDClient } from 'launchdarkly-react-client-sdk';

export default function WithLDUser({ children }) {
	const { user } = useSelector((state) => state);
	const ldClient = useLDClient();

	React.useEffect(
		() => {
			if (user.authenticated && user.customerIds.length) {
				const [textRecruitCustomer] = user.customerIds.filter((c) => c.product === 'TextRecruit');
				ldClient.identify({
					key: user.userName,
					firstName: user.firstName,
					lastName: user.lastName,
					custom: {
						customerId: textRecruitCustomer.customerId
					}
				});
			}
		},
		[user.customerIds]
	);
	return children;
}
